export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[720px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            关于香蕉漫画
          </h2>
          <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            <p>
              香蕉漫画成立于2024年，是一个专注韩漫、日漫、国漫推荐与分类索引的综合漫画平台。我们汇聚了全网热门漫画资源，按照恋爱、奇幻、热血、悬疑、搞笑等风格进行细致归类，帮助漫迷快速发现心仪作品。
            </p>
            <p>
              平台每日追踪最新漫画连载进度，提供高清画质的在线阅读体验，支持流畅的下拉式阅读模式。所有收录漫画均可免费阅读全集完整版，无需注册登录，打开网站即可畅享漫画世界。
            </p>
            <p>
              我们的编辑团队由资深漫迷组成，持续筛选高质量漫画作品，并定期发布人气排行榜与推荐专题。无论是热衷韩漫的浪漫故事、日漫的热血冒险，还是国漫的文化底蕴，香蕉漫画都为你一网打尽。
            </p>
            <p>
              香蕉漫画不仅是一个漫画推荐平台，更是一个连接漫迷与创作者的桥梁。我们欢迎漫画作者投稿原创作品，也期待与更多漫画平台建立合作关系，共同为中文漫画读者打造更丰富的阅读生态。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}